import {DeepLinkActionBase} from '../deep-link-action-base';

export class RedirectDeepLinkAction extends DeepLinkActionBase {
  async execute(): Promise<void> {

    if(this.descriptor.actionParams && this.descriptor.actionParams.id) {
      await this.services.location.push(this.descriptor.actionParams.id);
    }
  }
}
